import axios from 'axios';
import env from '../utils/env';

const config = env();
const axiosClient = axios.create({
  baseURL: config.apiURL,
  headers: {
    'Content-Type': 'application/json',
    'X-ACCESS-TOKEN': window.btoa(`${config.affiliatePublicKey}:${config.affiliateToken}`)
  }
});

export default axiosClient;
